import React, { useEffect, useState } from "react";
import { BaseBox, BaseTypography } from "../exports";

export default function BaseFooter() {
  const [currentDate, setCurrentDate] = useState(new Date().toGMTString());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(new Date().toGMTString());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <BaseBox
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        bgcolor: "#f1f1f1",
        borderTop: "1px solid #ddd",
        px: 2,
        py: 1,
        display: "flex",
        justifyContent: "flex-end",
        boxSizing: "border-box",
      }}
    >
      <BaseTypography sx={{ fontSize: "1em" }}>{currentDate}</BaseTypography>
    </BaseBox>
  );
}
